import React from 'react';
import { GetServerSideProps } from 'next';
import CenteredContainer from '@/common/CenteredContainer';
import ContactPage from '@/shared/pages/contact-us';

import initializePage from '../app/common/pageSetup';

const ContactUsPage = (): JSX.Element => (
    <>
      <CenteredContainer>
        <ContactPage />
      </CenteredContainer>
    </>
  );

export const getServerSideProps: GetServerSideProps = (ctx) => initializePage(ctx, 'contact-us');

export default ContactUsPage;
